import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { DATE_FORMAT_MMM_YYYY } from '@/helpers/common';
import { MODAL_IDS } from '@/kit/Modal/keys';
import s from './index.module.scss';

const id = MODAL_IDS.portfolio_movement_detail;

export const PortfolioMovementDetailModal = props => {
  const { modalIds } = useModal();
  return modalIds[id] && props.data && <Modal {...props} />;
};

export const Modal = ({ data, grouping }) => {
  const { t } = useTranslation('modal');
  const { closeModal } = useModal();

  const content = (
    <div className={s.modal}>
      <h1 className="f-article-accent">{t('portfolio_mv_modal.details')}</h1>
      <div className={s.content}>
        <div className={s.row}>
          <div className="f-small-regular">
            {grouping
              ? t('portfolio_mv_modal.round')
              : t('portfolio_mv_modal.claim')}
          </div>
          <div className="f-small-accent">
            {grouping
              ? prettyDate(data.fundraising_start_date, DATE_FORMAT_MMM_YYYY)
              : `#${data.loan_id}`}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">
            {t('portfolio_mv_modal.opening_principal')}
          </div>
          <div className="f-small-accent">
            {prettyFloatMoney(data.opening_principal, {
              decimalPlaces: 2,
            })}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">
            {t('portfolio_mv_modal.invested')}
          </div>
          <div className="f-small-accent">
            {prettyFloatMoney(data.invested, {
              decimalPlaces: 2,
            })}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">
            {t('portfolio_mv_modal.principal_repaid')}
          </div>
          <div className="f-small-accent">
            {prettyFloatMoney(data.principal_repaid, {
              decimalPlaces: 2,
            })}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">
            {t('portfolio_mv_modal.interest_received')}
          </div>
          <div className="f-small-accent">
            {prettyFloatMoney(data.interest_received, {
              decimalPlaces: 2,
            })}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">
            {t('portfolio_mv_modal.closing_principal')}
          </div>
          <div className="f-small-accent">
            {prettyFloatMoney(data.closing_principal, {
              decimalPlaces: 2,
            })}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalSwipeLayout>
  );
};
